<template>
  <button
    class="clickable-pop-up-icon"
    @click.prevent.stop="$emit('selected')"
    :disabled="disabled"
  >
    <TIcon
      v-if="!loading"
      :name="icon"
      :size="30"
      :color="color"
      :style="`opacity: ${icon_opacity};`"
    />
    <v-progress-circular
      v-else
      class="mr-1"
      size="36"
      width="4"
      :color="color"
      indeterminate
      />
    <TText
      :value="description"
      :size="9"
      :color="color"
      align="center"
      :underlined="is_underlined"
    />
  </button>
</template>

<script>
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    components: {
      TText,
      TIcon,
    },

    props: [
      'icon',
      // 'icon_color',
      'icon_opacity',
      'description',
      // 'description_color',
      'color',
      'is_underlined',
      'loading',
      'disabled',
    ],

    data: () => ({

    }),

    methods: {

    },
  }
</script>

<style>
.clickable-pop-up-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* grid-gap: 4px; */
}
</style>
